import React from 'react'
import PropTypes from 'prop-types'
import './banner1.css'
const Banner1 = (props) => {
  return (
    <div className="banner1-container1 thq-section-padding">
      <div className="banner1-max-width thq-section-max-width">
        <div className="banner1-container2">
          <h2 className="banner1-text3 thq-heading-1">
            {props.heading1 ?? "CAIC Members"}
          </h2>
          <h3 className="banner1-text4 thq-heading-3">
            {props.content1}
          </h3>
        </div>
        {/* <div className="members-grid">
          <div className="members-list">
            {['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'M', 'N', 'O', 'P', 'R', 'S', 'U', 'W'].map((letter) => (
              <div key={letter} className="members-column">
                <h3>{letter}</h3>
                <ul>
                  {letter === 'A' && (
                    <>
                      <li><a href="https://a2i.gov.bd/" target="_blank" rel="noopener noreferrer">A2i - Bangladesh</a></li>
                      <li><a href="https://www.ai4diversity.org/" target="_blank" rel="noopener noreferrer">AI for Diversity</a></li>
                      <li><a href="https://www.adb.org/" target="_blank" rel="noopener noreferrer">Asian Development Bank</a></li>
                    </>
                  )}
                  {letter === 'B' && (
                    <>
                      <li><a href="https://www.balcony.io" target="_blank" rel="noopener noreferrer">Balcony</a></li>
                      <li><a href="https://www.bom.mu/" target="_blank" rel="noopener noreferrer">Bank of Mauritius</a></li>
                      <li><a href="https://www.bloomberg.com/" target="_blank" rel="noopener noreferrer">Bloomberg</a></li>
                      <li><a href="https://www.businessmauritius.org/" target="_blank" rel="noopener noreferrer">Business Mauritius</a></li>
                    </>
                  )}
                  {letter === 'C' && (
                    <>
                      <li><a href="https://www.cibcfcib.com/" target="_blank" rel="noopener noreferrer">Caribbean Bank</a></li>
                      <li><a href="https://www.migrationmedicine.com/" target="_blank" rel="noopener noreferrer">Center for Migration Medicine</a></li>
                      <li><a href="https://www.csiro.au/" target="_blank" rel="noopener noreferrer">Commonwealth Scientific and Industrial Research Organization (CSIRO)</a></li>
                      <li><a href="https://www.credo.ai/" target="_blank" rel="noopener noreferrer">Credo.AI</a></li>
                      <li><a href="https://www.crowdai.com/" target="_blank" rel="noopener noreferrer">Crowd AI</a></li>
                      <li><a href="https://www.cyberpeace.org/" target="_blank" rel="noopener noreferrer">Cyberpeace</a></li>
                    </>
                  )}
                  {letter === 'D' && (
                    <>
                      <li><a href="https://www.deloitte.com/" target="_blank" rel="noopener noreferrer">Deloitte</a></li>
                      <li><a href="https://www.maltadigitali.mt/" target="_blank" rel="noopener noreferrer">Digital Affairs, Malta</a></li>
                      <li><a href="https://dco.org/" target="_blank" rel="noopener noreferrer">Digital Cooperation Organization</a></li>
                      <li><a href="https://www.digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">Digital India</a></li>
                    </>
                  )}
                  {letter === 'E' && (
                    <>
                      <li><a href="https://www.ericsson.com/" target="_blank" rel="noopener noreferrer">Ericsson</a></li>
                      <li><a href="https://www.experian.com/" target="_blank" rel="noopener noreferrer">Experian</a></li>
                    </>
                  )}
                  {letter === 'F' && (
                    <>
                      <li><a href="https://www.firmus.ai/" target="_blank" rel="noopener noreferrer">Firmus</a></li>
                    </>
                  )}
                  {letter === 'G' && (
                    <>
                      <li><a href="https://www.google.com/" target="_blank" rel="noopener noreferrer">Google</a></li>
                      <li><a href="https://ai.google/" target="_blank" rel="noopener noreferrer">Google AI for Good</a></li>
                      <li><a href="https://deepmind.com/" target="_blank" rel="noopener noreferrer">Google DeepMind</a></li>
                      <li><a href="https://www.globalpolicyhouse.com/" target="_blank" rel="noopener noreferrer">Global Policy House</a></li>
                      <li><a href="https://giet.ac.in/" target="_blank" rel="noopener noreferrer">Godavari Institute of Technology</a></li>
                      <li><a href="https://startup.google.com/programs/accelerator/middle-east-north-africa-turkey/" target="_blank" rel="noopener noreferrer">Google for Start-up (EU & MENA)</a></li>
                    </>
                  )}
                  {letter === 'H' && (
                    <>
                      <li><a href="https://www.hackmakers.com/" target="_blank" rel="noopener noreferrer">Hackmakers</a></li>
                      <li><a href="#" target="_blank" rel="noopener noreferrer">Health Parliament</a></li>
                      <li><a href="https://www.hp.com/" target="_blank" rel="noopener noreferrer">HP</a></li>
                      <li><a href="https://www.humani.ai/" target="_blank" rel="noopener noreferrer">Humani.ai</a></li>
                    </>
                  )}
                  {letter === 'I' && (
                    <>
                      <li><a href="https://www.ibm.com/" target="_blank" rel="noopener noreferrer">IBM</a></li>
                      <li><a href="https://www.iitk.ac.in/" target="_blank" rel="noopener noreferrer">IIT Kanpur</a></li>
                      <li><a href="https://www.imf.org/" target="_blank" rel="noopener noreferrer">IMF</a></li>
                      <li><a href="https://www.imxsoftware.com/" target="_blank" rel="noopener noreferrer">IMX Software</a></li>
                      <li><a href="https://intronhealthresearch.com/" target="_blank" rel="noopener noreferrer">Intron Health</a></li>
                    </>
                  )}
                  {letter === 'M' && (
                    <>
                      <li><a href="https://www.microsoft.com/" target="_blank" rel="noopener noreferrer">Microsoft</a></li>
                    </>
                  )}
                  {letter === 'N' && (
                    <>
                      <li><a href="https://www.nvidia.com/" target="_blank" rel="noopener noreferrer">Nvidia</a></li>
                    </>
                  )}
                  {letter === 'O' && (
                    <>
                      <li><a href="https://obreal.org/" target="_blank" rel="noopener noreferrer">OBREAL Global</a></li>
                      <li><a href="https://openclimatefix.org/" target="_blank" rel="noopener noreferrer">Open Climate Fix - Solar Forecasting</a></li>
                      <li><a href="https://openweaver.com/" target="_blank" rel="noopener noreferrer">Open Weaver</a></li>
                    </>
                  )}
                  {letter === 'P' && (
                    <>
                      <li><a href="https://www.path.org" target="_blank" rel="noopener noreferrer">Path</a></li>
                      <li><a href="https://www.planet.com/" target="_blank" rel="noopener noreferrer">Planet</a></li>
                    </>
                  )}
                  {letter === 'R' && (
                    <>
                      <li><a href="https://rss-hydro.lu" target="_blank" rel="noopener noreferrer">RSS - Hydro</a></li>
                    </>
                  )}
                  {letter === 'S' && (
                    <>
                      <li><a href="https://www.sas.com/" target="_blank" rel="noopener noreferrer">SAS Institute</a></li>
                    </>
                  )}
                  {letter === 'U' && (
                    <>
                      <li><a href="https://www.un.org/" target="_blank" rel="noopener noreferrer">UN</a></li>
                      <li><a href="https://www.unep.org/" target="_blank" rel="noopener noreferrer">UNEP</a></li>
                      <li><a href="https://unosat.org/" target="_blank" rel="noopener noreferrer">United Nations Satellite Centre</a></li>
                      <li><a href="https://www.berkeley.edu/" target="_blank" rel="noopener noreferrer">University of California, Berkley</a></li>
                      <li><a href="https://www.udom.ac.tz/" target="_blank" rel="noopener noreferrer">University of Dodoma</a></li>
                      <li><a href="https://www.uel.ac.uk/" target="_blank" rel="noopener noreferrer">University of East London</a></li>
                      <li><a href="https://www.sheffield.ac.uk/" target="_blank" rel="noopener noreferrer">University of Sheffield</a></li>
                      <li><a href="https://www.usp.ac.fj/" target="_blank" rel="noopener noreferrer">University of South Pacific</a></li>
                    </>
                  )}
                  {letter === 'W' && (
                    <>
                      <li><a href="https://www.worldbank.org/" target="_blank" rel="noopener noreferrer">World Bank</a></li>
                    </>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div> */}
        <div className="members-info">
          <p className="thq-body-medium" style={{ textAlign: 'justify'}}>
          The Commonwealth Artificial Intelligence Consortium is a global network of over 50 esteemed members and engagement partners, bringing together leading experts, organizations, and innovators from diverse sectors and regions. Our members represent a wide range of industries, from technology and academia to public policy and international development, all united by a shared commitment to advancing the responsible development and application of artificial intelligence.          </p>
          <br></br>
          <p className="thq-body-medium" style={{ textAlign: 'justify'}}>
            As a key platform for collaboration, CAIC facilitates knowledge sharing, fosters partnerships, and supports AI initiatives that benefit the Commonwealth and beyond. Our consortium plays an active role in shaping the future of AI through cutting-edge research, capacity-building programs, and policy development aimed at addressing global challenges and ensuring that AI technologies are used for the greater good.
          </p>
          <br></br>

          <p className="thq-body-medium" style={{ textAlign: 'justify'}}>
            For a full list of our distinguished members or to explore membership opportunities, we welcome you to reach out to us at <a href="/contact">caic@commonwealth.int</a>. Be part of a growing community that is driving innovation and fostering responsible AI practices across the world.
          </p>
        </div>
        <div className="cta-banner">
          <h2 className="cta-text">
            Become a part of our diverse consortium and lead the way in AI innovation and responsible practices.
          </h2>
          <a href="/contact" className="thq-button-filled cta-button">
            <span>Write to us to learn more about joining the CAIC</span>
          </a>
        </div>
        {props.children}
      </div>
    </div>
  )
}

Banner1.propTypes = {
  heading1: PropTypes.string,
  content1: PropTypes.string,
}

export default Banner1
